import request from "../composables/useHttp";

// 获取推荐新闻
export function getRecommendedNews(newsId) {
    return request("/news/gw/findGWRecommendedNewsByNewsTypeNotNewsId", {
        params: {newsId}
    })
}


// 获取新闻详情
export function getNewsDetail(newsId) {
    return request("/news/gw/findGWNewsDetailById", {
        params: {newsId}
    })
}